// Styles
import 'styles/index.css'

// Polyfills
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'core-js/features/string/repeat'
import 'core-js/es/object'
import 'core-js/es/symbol'
import 'core-js/es/symbol/iterator'
import 'core-js/es/map'
import 'core-js/es/set'
import 'regenerator-runtime/runtime'
import 'core-js/stable/url-search-params'
import 'services/polyfills'

// Core
import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter as Router} from 'react-router-dom'

// Components, services, etc
import App from './App'
import AppMain from 'views/AppMain'

// 3rd-party
import WebFont from 'webfontloader'

const renderApp = () => {
  ReactDOM.render(
    <React.StrictMode>
      <App>
        <Router basename={process.env.REACT_APP_BASENAME}>
          <AppMain />
        </Router>
      </App>
    </React.StrictMode>,
    document.getElementById('root')
  )
}

WebFont.load({
  active: renderApp, // render app after fonts are loaded to avoid incorrect calculation of nav bar size and position
  inactive: renderApp, // render the app if the fonts fail to load
  google: {
    families: ['Inter:400,500,600', 'sans-serif']
  },
  timeout: 1000
})
